import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactCrop from 'react-image-crop';
import ReactTooltip from 'react-tooltip';
import { ASSET_URL } from '../../env/Configurations';
import './ImageUpload.scss';
import './ReactCrop.scss';
import ScratchImagePicker from '../ui-builder/image-picker/Scratch-Image-Picker';
import { isEmpty } from 'lodash';

const ScratchImageUpload = (props) => {
  const {
    preImgURL,
    postImgURL,
    setPreImgURL,
    setPostImgURL,
    setIsUploading,
    cardType,
    popupImgURL,
    setPopupImgURL,
  } = props;
  const [editingImage, setEditingImage] = useState({
    index: -1,
    image: null,
    url: null,
  });

  const cropImgRef = useRef(null);

  const onLoad = useCallback((img) => {
    cropImgRef.current = img;
  }, []);

  const handleCropImageSelect = (index, url) => {
    setEditingImage({
      index: index,
      url,
    });
  };

  useEffect(() => {
    if (!preImgURL || !postImgURL || !popupImgURL) {
      setEditingImage({
        index: -1,
        image: null,
        url: null,
      });
    }
  }, [preImgURL, postImgURL, popupImgURL]);

  const onPreImageSelected = (val) => {
    setPreImgURL(val);
  };

  const onPostImageSelected = (val) => {
    setPostImgURL(val);
  };

  const onPopupImageSelected = (val) => {
    setPopupImgURL(val);
  };

  return (
    <>
      <ReactTooltip html={true} />
      <div className='row'>
        <div className='col-md-5 img-upload'>
          {cardType === 'SCRATCH_CARD' && (
            <>
              <div className='row pt-2'>
                <div className='img-drop-zone'>
                  <ScratchImagePicker
                    groupId={props?.groupId}
                    titleH2={'Image'}
                    ratio={'1:1'}
                    height={2800}
                    width={4096}
                    matrix={'px'}
                    onImageSelect={(e) => onPreImageSelected(e)}
                    isCustomImage={true}
                    imgURL={preImgURL}
                    onShadowOverlaySelect={(e) => {}}
                    format='PNG, JPG, GIF'
                    title='Pre-scratch Image/GIF'
                    accept={'image/png, image/jpg, image/jpeg, image/gif'}
                    setIsUploading={setIsUploading}
                  />
                </div>
              </div>
              <div className='row pt-2 mt-2'>
                <div className='img-drop-zone'>
                  <ScratchImagePicker
                    groupId={props?.groupId}
                    titleH2={'Image'}
                    ratio={'1:1'}
                    height={2800}
                    width={4096}
                    matrix={'px'}
                    onImageSelect={(e) => onPostImageSelected(e)}
                    isCustomImage={true}
                    imgURL={postImgURL}
                    format='PNG, JPG'
                    title='Post-scratch Image'
                    accept={'image/png, image/jpeg, image/jpg'}
                    setIsUploading={setIsUploading}
                  />
                </div>
              </div>
            </>
          )}

          {cardType === 'POPUP_CARD' && (
            <div className='row pt-2 mt-2'>
              <div className='img-drop-zone'>
                <ScratchImagePicker
                  groupId={props?.groupId}
                  titleH2={'Image'}
                  ratio={'1:1'}
                  height={2800}
                  width={4096}
                  matrix={'px'}
                  onImageSelect={(e) => onPopupImageSelected(e)}
                  isCustomImage={true}
                  imgURL={popupImgURL}
                  format='PNG, JPG'
                  title='Pop-up Image'
                  accept={'image/png, image/jpg'}
                  setIsUploading={setIsUploading}
                />
              </div>
            </div>
          )}
        </div>
        <div className='col-md-7 img-preview'>
          <div className={`shadow img-preview-top-margin ${!editingImage.url ? 'card' : ''}`}>
            <div
              className={`img-preview-cropper ${editingImage.image?.upImg ? 'image-added ' : ''} ${
                editingImage.url ? ' card' : ''
              }`}
            >
              <ReactCrop
                className='re-crop'
                src={editingImage.url ? ASSET_URL + editingImage.url : ''}
                onImageLoaded={onLoad}
                keepSelection={false}
                crop={{}}
                onChange={(c) => {}}
                onComplete={(c) => {}}
              />
            </div>
            {!editingImage.url && (
              <div className='mb-4 text-center text-under-image'>Click on image to preview</div>
            )}
          </div>
        </div>
      </div>
      <div className='row mt-4'>
        <div className='row mt-3'>
          {(!isEmpty(preImgURL) || !isEmpty(postImgURL)) && (
            <div>
              <span className='gray-text'>
                {cardType === 'SCRATCH_CARD'
                  ? !isEmpty(preImgURL) && !isEmpty(postImgURL)
                    ? '2 Images'
                    : !isEmpty(preImgURL) || !isEmpty(postImgURL)
                    ? '1 Image'
                    : '0 Images'
                  : cardType === 'POPUP_CARD'
                  ? !isEmpty(popupImgURL)
                    ? '1 Image'
                    : ' '
                  : ' '}
              </span>
            </div>
          )}
          <div className='col-md-4 d-flex mt-2 justify-content-between'>
            {cardType === 'SCRATCH_CARD' && (
              <>
                {!isEmpty(preImgURL) && (
                  <div className='preview-scratch-image'>
                    <img
                      alt={1}
                      src={ASSET_URL + preImgURL}
                      className={`${
                        editingImage.index === 0
                          ? 'image-scratch-border-highlight'
                          : 'image-scratch-border'
                      }`}
                      onClick={(e) => {
                        handleCropImageSelect(0, preImgURL);
                      }}
                      width={100}
                      height={100}
                    />
                  </div>
                )}
                {!isEmpty(postImgURL) && (
                  <div className='preview-scratch-image'>
                    <img
                      alt={1}
                      src={ASSET_URL + postImgURL}
                      className={`${
                        editingImage.index === 1
                          ? 'image-scratch-border-highlight'
                          : 'image-scratch-border'
                      }`}
                      onClick={(e) => {
                        handleCropImageSelect(1, postImgURL);
                      }}
                      width={100}
                      height={100}
                    />
                  </div>
                )}
              </>
            )}
            {cardType === 'POPUP_CARD' && !isEmpty(popupImgURL) && (
              <div className='preview-scratch-image'>
                <img
                  alt={1}
                  src={ASSET_URL + popupImgURL}
                  className={`${
                    editingImage.index === 1
                      ? 'image-scratch-border-highlight'
                      : 'image-scratch-border'
                  }`}
                  onClick={(e) => {
                    handleCropImageSelect(0, popupImgURL);
                  }}
                  width={100}
                  height={100}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScratchImageUpload;
